import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';

import SolvingIcon from '@material-ui/icons/DirectionsRun';

var numeral = require('numeral');

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.yellow[500],
    height: 56,
    width: 56
  }
}));

const Solving = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              EM TRATAMENTO
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              ({numeral(rest.count).format('0')})
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <SolvingIcon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

Solving.propTypes = {
  className: PropTypes.string
};

export default Solving;
